import styled from 'styled-components';
import { Accordion } from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex: 1;
  margin: 80px auto 0px auto;
  max-width: 1200px;
`;

const CustomAccordion = styled(Accordion)`
  &&& {
    border-radius: 0;
    border: solid 1px ${(props) => props.theme.color.checkboxAccordion};
    box-shadow: 0 0 #fff;
    width: 100%;
    margin-top: 10px;

    details {
      padding: 0.5em 1em 1.5em !important;
      color: ${(props) => props.theme.color.textHeader} !important;

      > summary {
        padding-bottom: 10px !important;
        cursor: pointer;
        font-weight: bold;
      }

      span {
        margin: 1em 0;
        display: block;
      }

      ol,
      ul {
        margin-left: 1em;

        > li {
          margin-bottom: 0.5em;
        }
      }
    }

    > div.title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: ${(props) => props.theme.color.textHeader};
      padding: 0.5em 2em 1.5em;

      @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
      }

      > h3 {
        color: ${(props) => props.theme.color.textHeader};
        margin: calc(2rem - 0.14285714em) 0 1rem;
      }
    }
  }
`;

const Button = styled(ButtonLayoutComponent)`
  width: 160px;

  @media (max-width: 768px) {
    margin-top: 20px !important;
  }
`;

const Heading = styled(TextLayoutComponent.Header)`
  font-size: 18px;
  margin: 0 25px;
  text-align: center;
`;

const AccordionList = styled.ul`
  width: 100%;
`;

export {
  Container,
  CustomAccordion,
  Button,
  Heading,
  AccordionList,
};
